import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';

const faqs = [
  {
    q: '在57漫画网如何免费阅读漫画？',
    a: '无需注册登录，进入作品详情页点击任意章节即可开始下拉式免费阅读。韩漫与热门漫画均提供高清无删减版本，滑动页面即可连续翻页，畅享丝滑阅读体验。',
  },
  {
    q: '《炸裂吧！巨棒》多久更新一次？',
    a: '该作品每周三、周日双更，最新章节会第一时间同步上线，你可以在作品页查看最近更新时间与最新章节标题，追更从不错过。',
  },
  {
    q: '为什么下拉式阅读更流畅？',
    a: '平台采用瀑布流分镜加载与智能预加载技术，滑动即读、无需手动翻页，同时自动记录你的阅读进度，下次打开无缝续读。',
  },
  {
    q: '什么是阅读元宇宙社交？',
    a: '这是57漫画网打造的社交阅读玩法：读者可以在虚拟漫画咖啡馆中创建自己的化身，与其他读者交流阅读心得、组队追更、参加每晚8点的主题分享会，让阅读更有温度。',
  },
  {
    q: '网站上的漫画是否无删减？',
    a: '平台内的韩漫与国产漫画均提供无删减高清版本，力求原汁原味呈现作者创作，请放心阅读。',
  },
  {
    q: '遇到加载或阅读问题怎么办？',
    a: '可以尝试刷新页面或切换网络环境；若问题依旧存在，欢迎通过关于我们页面的联系表单或客服邮箱 support@57mh.net 反馈，我们会第一时间处理。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="bg-background-100 py-10 md:py-14" aria-label="常见问题">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <SectionHeading title="常见问题" subtitle="关于免费阅读与阅读元宇宙，你想知道的都在这里" />
        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? 'border-primary-300' : 'border-background-200'
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left text-sm font-bold text-foreground-900 transition-colors hover:text-primary-700 md:px-5 md:py-4 md:text-base"
                  >
                    <span className="flex items-center gap-2.5">
                      <i className={`${open ? 'ri-question-fill' : 'ri-question-line'} h-4 w-4 text-primary-500`} aria-hidden="true"></i>
                      {faq.q}
                    </span>
                    <i
                      className={`${open ? 'ri-subtract-line' : 'ri-add-line'} h-5 w-5 shrink-0 text-foreground-400 transition-transform`}
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
                {open && (
                  <p className="border-t border-background-200 px-4 py-3.5 text-xs leading-6 text-foreground-600 md:px-5 md:py-4 md:text-sm">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}